<template>
  <div>
    <ImageSlider :aspectRatio="0.75" :value="productImageArray"></ImageSlider>
        <!-- Product Commission -->
    <div v-if="isShopOwner" class="commissionRateContainer commissionImg" >
      <span class="commissionRateText">{{getPercentage(detail.commissionRate)}}</span>
    </div>
    <!-- Product Title -->
    <div class="H5Container">
      <b-container class="titleContainer bottomBorder">
        <h5 class="productTitle multiline-ellipsis">{{getLocaleData(detail,'name')}}</h5>
        <div class="row mx-0 mt-2 justify-content-between">
          <h5 class=" primaryColorText productPrice d-block"><span style="font-size: 1rem;">{{$t('kol.priceUnit')}}</span> {{getExchangePrice(detail.marketPrice)}}</h5>
          <!-- Fullist Product Detail -->
          <div v-if="getRouteStatus.module != 'Shop'">
            <!-- Not in Shopping Cart -->
            <b-col cols="auto" class="row mx-0 px-0 justify-content-between">
              <FITButton v-if="getRouteStatus.module != 'Shop'" @click.native="selectProduct()" class="productBtn" :iconOnly="true" faIcon="fa-heart" variant="outline-danger"></FITButton>
              <FITButton v-if="detail.attributeVariation.length == 0" @click.native="addToCart()" class="productBtn" :iconOnly="true" faIcon="fa-shopping-cart" variant="outline-danger"></FITButton>
              <FITButton v-else @click.native="showAddToCart()" class="productBtn" :iconOnly="true" faIcon="fa-cart-arrow-down" variant="outline-danger"></FITButton>
              <b-modal v-model="addToCartModal" centered size="xl" style="width:100%" @ok="addToCart()">
                  <b-img class="modalImage" :src="getImageUrl(detail.imageMain)" center=""></b-img>
                  <div class="row mx-0 mt-1 justify-content-center">
                    <div style = "padding: 10px">
                      <span v-if="redirect !== 'true'" class="d-block cardPrice primaryColorText">
                        <span style="font-size: 0.8rem;">{{$t('kol.promote')}}{{$t('kol.priceUnit')}}</span>
                        <span>{{ selectedProductPrice }}</span>
                        <span v-if="detail.originalPrice !== '0' " style="font-size: 0.8rem; color: grey; text-decoration: line-through;">{{ detail.originalPrice }}</span>
                      </span>
                      <span v-else-if="detail.originalPrice !== '0' && redirect == 'true'" class="d-block cardPrice primaryColorText">{{$t('kol.priceUnit')}} {{detail.originalPrice}}</span>
                      <span v-else class="d-block cardPrice primaryColorText">{{$t('kol.priceUnit')}} {{ selectedProductPrice }}</span>
                    </div>
                    <b-form-select v-model="selectedProduct" :options="options">
                      <template v-slot:first>
                        <option :value="null">{{$t('kol.choose')}}</option>
                      </template>
                    </b-form-select>
                  </div>
              </b-modal>
            </b-col>
            <!-- In Shopping Cart -->
            <!-- <b-col v-else cols="auto" class="row mx-0 px-0 justify-content-between">
              <FITButton class="productBtn mr-2" :iconOnly="true" faIcon="fa-minus" variant="outline-danger" @click.native="updateProductQuantity(-1)"></FITButton>
              <span class="px-1 primaryColorText quantityText">{{productQuantity}}</span>
              <FITButton @click.native="updateProductQuantity(1)" class="productBtn" :iconOnly="true" faIcon="fa-plus" variant="outline-danger"></FITButton>
              <FITButton @click.native="goToCart()" class="productBtn" :iconOnly="true" faIcon="fa-shopping-cart" variant="outline-danger"></FITButton>
            </b-col> -->
          </div>
          <div v-else>
            <!-- Not in Shopping Cart -->
            <b-col cols="auto" class="row mx-0 px-0 justify-content-between">
              <FITButton v-if="isShopOwner " class="productBtn " :iconOnly="true" faIcon="fa-trash-alt" variant="outline-danger" @click="showDeleteConfirm"></FITButton>
              <FITButton v-if="isShopOwner " class="productBtn " :iconOnly="true" faIcon="fa-share-square" variant="outline-danger" @click="openDialog" v-clipboard="copyData" @success="copySuccess" @error="copyError"></FITButton>
              <span v-if="detail.status == 'A'">
                <FITButton v-if="detail.attributeVariation.length == 0 " @click.native="addToCart()" class="productBtn" :iconOnly="true" faIcon="fa-shopping-cart" variant="outline-danger"></FITButton>
                <FITButton v-else @click.native="showAddToCart()" class="productBtn" :iconOnly="true" faIcon="fa-cart-arrow-down" variant="outline-danger"></FITButton>
              </span>
              <b-modal v-model="addToCartModal" centered size="xl" style="width:100%" @ok="addToCart()">
                  <b-img class="modalImage" :src="getImageUrl(detail.imageMain)" center=""></b-img>
                  <div class="row mx-0 mt-1 justify-content-center">
                    <div style = "padding: 10px">
                      <span v-if="redirect !== 'true'" class="d-block cardPrice primaryColorText">
                        <span style="font-size: 0.8rem;">{{$t('kol.promote')}}{{$t('kol.priceUnit')}}</span>
                        <span>{{ selectedProductPrice }}</span>
                        <span v-if="detail.originalPrice !== '0' " style="font-size: 0.8rem; color: grey; text-decoration: line-through;">{{ detail.originalPrice }}</span>
                      </span>
                      <span v-else-if="detail.originalPrice !== '0' && redirect == 'true'" class="d-block cardPrice primaryColorText">{{$t('kol.priceUnit')}} {{detail.originalPrice}}</span>
                      <span v-else class="d-block cardPrice primaryColorText">{{$t('kol.priceUnit')}} {{ selectedProductPrice }}</span>
                    </div>
                    <b-form-select v-model="selectedProduct" :options="options">
                      <template v-slot:first>
                        <option :value="null">{{$t('kol.choose')}}</option>
                      </template>
                    </b-form-select>
                  </div>
              </b-modal>
            </b-col>
            <!-- In Shopping Cart -->
            <!-- <b-col v-else cols="auto" class="row mx-0 px-0 justify-content-between">
              <FITButton class="productBtn mr-2" :iconOnly="true" faIcon="fa-minus" variant="outline-danger" @click.native="updateProductQuantity(-1)"></FITButton>
              <span class="px-1 primaryColorText quantityText">{{productQuantity}}</span>
              <FITButton @click.native="updateProductQuantity(1)" class="productBtn" :iconOnly="true" faIcon="fa-plus" variant="outline-danger"></FITButton>
               <FITButton v-if="isShopOwner " class="productBtn " :iconOnly="true" faIcon="fa-trash-alt" variant="outline-danger" @click="showDeleteConfirm"></FITButton>
              <FITButton v-if="isShopOwner " class="productBtn " :iconOnly="true" faIcon="fa-share-square" variant="outline-danger" @click="openDialog" v-clipboard="copyData" @success="copySuccess" @error="copyError"></FITButton>
              <FITButton @click.native="goToCart()" class="productBtn " :iconOnly="true" faIcon="fa-shopping-cart" variant="outline-danger"></FITButton>
            </b-col> -->
          </div>
          <div v-transfer-dom>
                <x-dialog v-model="show" class="dialog-demo">
                  <social-sharing :url="copyData"
                      :title="$t('kol.footer.shop')+'-'+$t('account.credit.title')"
                      description="KOL platform"
                      :quote="$t('kol.footer.shop')+'-'+$t('account.credit.title')"
                      hashtags=""
                      twitter-user=""
                      inline-template>
                      <div>
                      <network network="facebook">
                        <i class="fab fa-facebook-f"></i> Facebook
                      </network>
                      </div>
                  </social-sharing>
                  <div style="margin:5px">
                  <a :href="whatsappShareText" target="_blank"><i class="fab fa-whatsapp"></i> Whatsapp</a>
                  </div>
                    <FITButton v-if="isShopOwner " style="margin:0px !important" :size="'md'" class="productBtn " :iconOnly="true" faIcon="fa-share" variant="link" @click="shareCurrentPage" v-clipboard="copyData" @success="copySuccess" @error="copyError" :text="'share'"></FITButton>
                  <div @click="show=false">
                    <span class="vux-close">Close</span>
                  </div>
                </x-dialog>
              </div>
        </div>
        <div v-if="detail.status == 'I'" style="text-align: center; color: red; font-size: 20px; padding-top: 10px">此商品已下架或不適用於此頁面</div>
      </b-container>
      <!-- Shipping Cost -->
      <b-container class="titleContainer">
        <div class="row mx-0 justify-content-between">
          <b-col cols='5' class="px-0">
            <h5 class=" textBodyColor textBody d-block">{{$t('product.detail.shippingCost')}}</h5>
          </b-col>
        </div>
      </b-container>
    </div>
    <!--  Product Description -->
    <!--     <img src='http://www.garancedore.com/wp-content/uploads/2016/09/context-nail-polish_garance-dore-770x502.jpg' class="img-fluid w-100">
        <p class="my-3 ">商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情</p>
        <img src='https://cdn.shopify.com/s/files/1/1041/6940/products/57_2.jpg?v=1498783995' class="img-fluid w-100">
        <p class="my-3 ">商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情商品詳情</p> -->
    <WXContainer v-if="getLocaleData(detail,'description')">
      <template slot="title">
        <h5 class=" textTitleColor textBody d-block" style="font-size: 1rem;">{{$t('product.detail.containerTitle.description')}}</h5>
      </template>
      <template slot="body">
        <div class="container" v-html="getLocaleData(detail,'description')"></div>
      </template>
    </WXContainer>
    <!-- Product Feature -->
    <WXContainer v-if="getLocaleData(detail,'feature')">
      <template slot="title">
        <h5 class=" textTitleColor textBody d-block" style="font-size: 1rem;">{{$t('product.detail.containerTitle.feature')}}</h5>
      </template>
      <template slot="body">
        <div class="container" v-html="getLocaleData(detail,'feature')"></div>
      </template>
    </WXContainer>
    <!-- Related Product -->
    <GridContainer :VuexModule="getRouteStatus.module" class="my-2"></GridContainer>
    <div v-transfer-dom>
      <alert :button-text="alertBtnText" v-model="showAlert">{{alertMsg}}</alert>
    </div>
    <div v-transfer-dom>
      <confirm :cancel-text="$t('kol.header.cancel')" :confirm-text="$t('kol.header.confirm')" v-model="showConfirm" :title="confirmMsg" @on-confirm="deleteProduct"></confirm>
    </div>
  </div>
</template>
<script type="text/javascript">
import { FITFormCard, FITCheckbox, FITSelect, FITTextInput, FITInputTag, FITButton, ImageSlider, WXContainer } from '@/components'
import { mapGetters } from 'vuex'
import GridContainer from '../components/GridContainer'
import $ from 'jquery'
import { TransferDom, Alert, Confirm,XDialog } from 'vux'
import Cookies from 'js-cookie'


export default {
  name: 'ProductDetail',
  directives: {
    TransferDom
  },
  components: {
    FITCheckbox,
    FITSelect,
    FITTextInput,
    FITInputTag,
    FITButton,
    FITFormCard,
    ImageSlider,
    WXContainer,
    GridContainer,
    Alert,
    Confirm,
    XDialog
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
    }
  },
  data() {
    return {
      detail: {
        marketPrice: ''
      },
      showAlert: false,
      alertMsg: '',
      alertBtnText: this.$t('kol.header.confirm'),
      showConfirm: false,
      confirmMsg: '',
      show:false,
      addToCartModal: false,
      selectedProduct: null,
      selectedProductPrice: this.value.marketPrice,
      options: [],
    }
  },
  created() {
    let query = this.currentRoute.query;
    if (($.isEmptyObject(this.value)) && (query.ID)) {
      this.getProductDetail(query.ID);
    }else if ($.isEmptyObject(this.value) && (query.product)) {
      this.getKOLProductDetail(query.product);
    }
     else {
      this.detail = this.value;
      this.detail.quantity = this.productQuantity;
    }
    // console.log(this.detail);
    document.title = `${this.getLocaleData(this.detail,'name')} - ${this.$t('kol.title')}`
    if(this.detail.attributeVariation){
      for(let i=0; i<this.detail.attributeVariation.length; i++){
        this.options.push({
          value: this.detail.attributeVariation[i].ID,
          text: this.detail.attributeCategory1+'﹕'+this.detail.attributeVariation[i].attribute1+'，'+
          this.detail.attributeCategory2+'﹕'+this.detail.attributeVariation[i].attribute2
        })
      }
    }
  },
  mounted() {},
  computed: {
       isShopOwner() {
      let result = false;
      let role = this.currentRole;
      let currentShopLink = this.$router.currentRoute.query.link;
      let cookieShopLink = Cookies.get('shopLink');

      if(role == "K" || role == 'R'){
          result = true;
      }
      if(currentShopLink){
        if(currentShopLink == cookieShopLink){
          return true;
        }
      }
      return result;
    },
    copyData() {
      let string = document.title + '\n\n';
      let copyData = "";
      console.log(this.$router.currentRoute)
      // live server 
      if(this.$router.currentRoute.query.packages){
        copyData = 'https://mobile.kolpartner.com/ProcessPage.php?packages=' + this.$router.currentRoute.query.packages + '&link='+ this.$router.currentRoute.query.link;
      }
      else{
        copyData = 'https://mobile.kolpartner.com/ProcessPage.php?product=' + this.$router.currentRoute.query.product + '&link='+ this.$router.currentRoute.query.link;
      }
      // test server 
      // if(this.$router.currentRoute.query.packages){
      //   copyData = 'https://test.ftech.com.hk/kol-h5/ProcessPage.php?packages=' + this.$router.currentRoute.query.packages + '&link='+ this.$router.currentRoute.query.link;
      // }
      // else{
      //   copyData = 'https://test.ftech.com.hk/kol-h5/ProcessPage.php?product=' + this.$router.currentRoute.query.product + '&link='+ this.$router.currentRoute.query.link;
      // }
      
      // let copyData = 'https://mobile.kolpartner.com' + this.$router.currentRoute.fullPath;
      // string += copyData;
      // console.log(string);
      return copyData;
    },
    currentRole() {
      return Cookies.get('role');
    },
    currentRoute() {
      return this.$router.currentRoute;
    },
    ...mapGetters([
      'getImageUrl',
      'getTranslatedData',
      'getProductCardQuantityByID',
      'getRouteStatus',
      'getExchangePrice',
      'getPercentage'
    ]),
    productQuantity() {
      let productID;
      if (this.detail.productID) {
        productID = this.detail.productID;
      } else {
        productID = this.detail.ID;
      }
      //add attribute id
      let quantity = this.getProductCardQuantityByID(productID,this.selectProduct);
      this.detail.quantity = quantity;
      return quantity;
    },
    productImageArray() {
      let product = this.detail;
      let keyArray = ['imageMain', 'exImage1', 'exImage2', 'exImage3', 'exImage4'];
      let images = [];
      // console.log(product)
      $.each(keyArray, (index, keyName) => {
        // console.log(keyName);
        // console.log(product[keyName]);
        if (product[keyName]) {
          let imgObj = {
            url: 'javascript:',
            img: this.getImageUrl(product[keyName]),
            title: ''
          };
          images.push(imgObj);
        }
      });
      return images;
    },
    whatsappShareText(){
      var link = 'https://api.whatsapp.com/send?text='+'%0A'+ encodeURIComponent(this.copyData)
      return link
    },

  },
  methods: {
    getKOLProductDetail(productLink) {
      let param = {
        link: productLink
      }
      this.$store.dispatch('Shop/getKOLProductDetail', param).then((json) => {
        this.detail = json.data;
        this.detail.quantity = this.productQuantity;
        document.title = `${this.getLocaleData(this.detail,'name')} - ${this.$t('kol.title')}`

      })
    },
    getProductDetail(ID) {
      let param = {
        ID: ID
      }
      this.$store.dispatch('Product/getFullProductList', param).then((json) => {
        this.detail = json.data.list[0];
        this.detail.quantity = this.productQuantity;
        document.title = `${this.getLocaleData(this.detail,'name')} - ${this.$t('kol.title')}`

      })
    },
    getLocaleData(data, key) {
      return this.getTranslatedData(this.$i18n.locale, data, key);
    },
    selectProduct() {
      this.$store.dispatch('Product/selectProduct', { productID: [this.detail.ID] }).then((json) => {
        this.alertMsg = this.$t('product.list.selectSuccess');
        this.showAlert = true;
      });
    },
    addToCart() {
      this.detail.quantity = 1;
      this.detail.selectedProduct = this.selectedProduct
      // if(this.product.selectedProduct !== null){
      this.$store.dispatch('addProductToCart', this.detail);
      // }
    },
    goToCart(){
      this.$router.push({
        name:"Cart"
      })
    },
    updateProductQuantity(delta) {
      this.detail.quantity += delta;
      this.$store.dispatch('updateProductInCart', this.detail);
    },
    showDeleteConfirm() {
      this.showAction = false;
      this.confirmMsg = this.$t('product.list.removeConfirm');
      this.showConfirm = true;
    },
    shareCurrentPage() {
      this.alertBtnText = this.$t('shop.detail.shareConfirmText');
      this.alertMsg = this.$t('shop.detail.shareBodyText');
      this.showAlert = true;
    },
    copySuccess(e) {
      console.log('Success: ' + e);
    },
    copyError(e) {
      console.log('Error: ' + e);
    },
    deleteProduct() {
      this.$store.dispatch('Shop/deleteProduct', { ID: [this.detail.ID] }).then((json) => {
        this.showConfirm = false;
        this.$router.push({
          name:"KOL Shop"
        })
      });
    },
    openDialog(){
      this.show = true;
    },
    showAddToCart() {
      this.addToCartModal = !this.addToCartModal;
    },
    redirect() {
      return Cookies.get('redirect');
    }
  },
  watch: {
    value: {
      handler: function(val, oldVal) {
        this.detail = val;
        this.detail.quantity = this.productQuantity;
        this.options = [];
        if(this.detail.attributeVariation){
          for(let i=0; i<this.detail.attributeVariation.length; i++){
            this.options.push({
              value: this.detail.attributeVariation[i].ID,
              text: this.detail.attributeCategory1+'﹕'+this.detail.attributeVariation[i].attribute1+'，'+
              this.detail.attributeCategory2+'﹕'+this.detail.attributeVariation[i].attribute2
            })
          }
        }
      },
      deep: true
    },
    selectedProduct: {
      handler: function(val) {
        if(this.detail.attributeVariation){
          for(let i=0; i<this.detail.attributeVariation.length; i++){
            if(this.detail.attributeVariation[i].ID == this.selectedProduct ){
              this.selectedProductPrice = this.detail.attributeVariation[i].price
            }else if(this.selectedProduct == null){
              this.selectedProductPrice = this.detail.marketPrice
            }
          }
        }
      }
    }
  },
}

</script>
<style type="text/css">
.titleContainer {
  background: white;
  padding: 12px 16px;
}

.productTitle {
  font-weight: 500;
  letter-spacing: 0rem;
  color: #555;
  font-size: 1.1rem;
  line-height: 1.5rem;
  display: inline-block;
  overflow: hidden;
  height: 50px;
}

.multiline-ellipsis {
  display: block;
  display: -webkit-box;
  max-width: 400px;
  margin: 0 auto;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.productPrice {
  margin: 0px;
  display: block;
  font-size: 1.5rem;
  font-weight: 500;

}

.productBtn {
  margin: 0px 4px !important;
  font-size: 1.1rem;
  padding: 1px 6px;
 text-align: center;
  cursor: pointer;

}
.quantityText{
  font-size: 1.2rem; 
}
.commissionImg{
    background-image: url('../../assets/img/commissionTag.png');

}
</style>



// WEBPACK FOOTER //
// src/Product/containers/ProductDetail.vue